import { AddIcon } from "components/common/Icons/AddIcon";
import { DeleteIcon } from "components/common/Icons/DeleteIcon";
import { SortIcon } from "components/common/Icons/SortIcon";
import { useAppSelector } from "store/store";
import type { ActiveType } from "../useBottomMenu";
import { DownloadAll } from "./DownloadAll/DownloadAll";

export interface OptionsProps {
    openPopup: (activeType: ActiveType) => void;
}

export const Options = ({ openPopup }: OptionsProps) => {
    const { state } = useAppSelector((state) => state.compress.downloadButtonState);
    const { images } = useAppSelector((state) => state.compress);

    const isActive = state === "active" && images.length > 0;

    return (
        <div className="bg-irBlue-200 dark:bg-darkPrimary-100 rounded-xl flex items-center w-full">
            <div
                className="flex items-center justify-center py-4 px-4 border-r border-r-irBlue-400 cursor-pointer "
                onClick={(e) => {
                    e.stopPropagation();
                    openPopup("add");
                }}
            >
                <AddIcon className="fill-white" />
            </div>

            <div
                className={`flex items-center justify-center py-4 px-4 border-r border-r-irBlue-400 ${
                    !isActive
                        ? "bg-gray-400 text-white-600 border-gray-400 border-t-4 border border-b-4 "
                        : "cursor-pointer "
                }`}
                onClick={(e) => {
                    if (!isActive) return;
                    e.stopPropagation();
                    openPopup("delete");
                }}
            >
                <DeleteIcon className={`fill-white`} />
            </div>

            <DownloadAll />
       
            <div
                className={`flex items-center justify-center py-4 px-4 ${
                    !isActive
                        ? "bg-gray-400 text-white-600 border-gray-400 border-t-8 border border-b-4 rounded-r-xl"
                        : "cursor-pointer "
                }`}
                onClick={(e) => {
                    if (!isActive) return;
                    e.stopPropagation();
                    openPopup("sort");
                }}
            >
                <SortIcon className={`fill-white`} />
            </div>
        </div>
    );
};
